// extracted by mini-css-extract-plugin
module.exports = {"checkboxGroup":"checkboxGroup_checkboxGroup__3i1-l","inline":"checkboxGroup_inline__LkP2M"};